// extracted by mini-css-extract-plugin
module.exports = {"table1":"table_table1__Qf_GU","table2":"table_table2__q_zaR","fullWidth":"table_fullWidth__LSBpD"};